import storage from 'redux-persist/lib/storage';

export const strapiPersistConfig = {
  key: 'strapi',
  storage,
};
